import { Component, inject, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ApiAuthService } from '../shared/data-access/api/api-auth.service';
import { ApiSessionService } from '../shared/data-access/api/api-session.service';

@Component({
  selector: 'mc-login', standalone: true, imports: [ReactiveFormsModule],
  templateUrl: './login.component.html', styleUrl: './login.component.scss',
})
export class LoginComponent {
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly auth = inject(ApiAuthService);
  private readonly session = inject(ApiSessionService);
  readonly submitting = signal(false);
  readonly error = signal('');
  readonly isMock = environment.dataSource === 'mock';
  readonly form = this.fb.nonNullable.group({ username: ['', Validators.required], password: ['', Validators.required] });

  submit(): void {
    if (this.form.invalid || this.submitting()) { this.form.markAllAsTouched(); return; }
    this.error.set(''); this.submitting.set(true);
    if (this.isMock) { this.navigateAfterLogin(); return; }
    const { username, password } = this.form.getRawValue();
    this.auth.login(username, password).subscribe({
      next: () => this.session.refreshMe().subscribe({ next: () => { this.submitting.set(false); this.navigateAfterLogin(); }, error: () => this.fail('Session utilisateur indisponible.') }),
      error: (err: { status?: number }) => { this.auth.clear(); this.session.clearProfile(); this.fail(err.status === 401 ? 'Identifiants invalides.' : 'Connexion au serveur impossible.'); },
    });
  }

  private fail(message: string): void { this.submitting.set(false); this.error.set(message); }

  private navigateAfterLogin(): void {
    const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    const target = returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//')
      ? returnUrl
      : '/dashboard';
    void this.router.navigateByUrl(target);
  }
}
